import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

import { Button } from '@/components/ui/button';

/**
 * 未捕获异常的兜底页面，替代平台的 ErrorRender。
 * 开发态展示堆栈方便定位，生产态只给一句话和重试按钮。
 */
export interface ErrorRenderProps {
  error: Error;
  resetErrorBoundary?: () => void;
}

export const ErrorRender: React.FC<ErrorRenderProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const isDev: boolean = process.env.NODE_ENV === 'development';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-7 w-7 text-destructive" />
      </div>
      <h1 className="text-lg font-semibold text-foreground">页面出错了</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {isDev ? error.message : '请刷新重试，若持续出现请联系管理员。'}
      </p>
      {isDev && error.stack ? (
        <pre className="max-h-64 max-w-2xl overflow-auto rounded-lg bg-muted p-4 text-left text-xs text-muted-foreground">
          {error.stack}
        </pre>
      ) : null}
      {resetErrorBoundary ? (
        <Button onClick={resetErrorBoundary} variant="outline">
          <RotateCcw className="mr-2 h-4 w-4" />
          重试
        </Button>
      ) : null}
    </div>
  );
};

export default ErrorRender;
